/* @ngInject */
function confirmationModalService ($q, $translate, UdsModalService) {
  const getConfimationDialogController = () => $q.when(import('../dialogs/confirmation-dialog/confimation-dialog.controller'))

  const service = {
    createModal
  }

  return service

  function createModal (params = {}) {
    const {
      title = $translate.instant('warning'),
      description = $translate.instant('areYouSureWantConfirm'),
      htmlDescription = null,
      buttonCancelText = $translate.instant('cancel'),
      buttonConfirmText = $translate.instant('yes'),
      hideCancelButton = false,
      onConfirm = () => {},
      onCancel = () => {}
    } = params

    getConfimationDialogController().then(({ ConfirmationDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: ConfirmationDialogController,
        modalName: 'confirmationDialog',
        data: {
          title,
          description,
          htmlDescription,
          buttonCancelText,
          buttonConfirmText,
          hideCancelButton,
          onConfirm,
          onCancel
        }
      })
      modal.open()
    })
  }
}

export { confirmationModalService }
